var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-toast",class:{ 'is-on': _vm.visible, 'is-success': _vm.type === 'success' }},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }